import React, { useState, useEffect } from 'react';
import './OneToOneReview.css';
import './createadmin.css';
import sortIcon from './images/sort.png';
import msortIcon from './images/msort.png';

const ThankYouReview = () => {
  const [thankyou, setThankyou] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'ascending' });
  const [userRole, setUserRole] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const fetchUserRole = () => {
      const role = localStorage.getItem('role');
      const id = localStorage.getItem('userId');
      setUserRole(role);
      setUserId(id);
    };

    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/thankyouslip`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error('Failed to fetch thank you slips');
        const data = await response.json();
        setThankyou(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserRole();
    fetchData();
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = userRole === 'admin'
    ? thankyou
    : thankyou.filter((entry) => entry.user?._id === userId);

  const searchedData = searchQuery
    ? filteredData.filter((entry) =>
      entry.user?.firstName.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : filteredData;

  const sortData = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'ascending' ? 'descending' : 'ascending',
    }));
  };

  const sortedData = [...searchedData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'ascending' ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'ascending' ? 1 : -1;
    return 0;
  });

  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}-${d.toLocaleString('default', { month: 'short' })}-${d.getFullYear()}`;
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="table-container">
          <h2 className="AddOneToOne">View Thank You Slip</h2>

          <div className="search-containerOne">
            <input type="text" placeholder="Search" value={searchQuery} onChange={handleSearch} />
          </div>

          {/* Desktop View */}
          <div className="desktop-table">
            <table className="table-heading">
              <thead>
                <tr>
                  <th className="sticky-col">S.No</th>
                  <th onClick={() => sortData('date')}>Date <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('date')}>Giver Name <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('name')}>Reciver Name <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('amount')}>Amount <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('type')}>Type <img src={sortIcon} alt="Sort" /></th>
                </tr>
              </thead>
              <tbody>
                {sortedData.length > 0 ? (
                  sortedData.map((entry, index) => (
                    <tr key={entry._id}>
                      <td className="sticky-col">{index + 1}</td>
                      <td>{entry.date ? formatDate(entry.date) : '--'}</td>
                      <td>{entry.name || 'Unknown'}</td>
                      <td>{entry.user?.firstName} {entry.user?.lastName}</td>
                      <td>{entry.amount ?? '--'}</td>
                      <td>{entry.type ?? '--'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="mobile-scroll-table-add">
            <div className="mobile-scroll-wrapper">
              <table>
                {/* <thead> */}
                  <tr>
                    <th>S.No</th>
                    {sortedData.map((_, index) => (
                      <td key={`col-${index}`}>{index + 1}</td>
                    ))}
                  </tr>
                {/* </thead> */}
                <tbody>
                  <tr>
                    <th>Date <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, index) => (
                      <td key={`date-${index}`}>{formatDate(entry.date)}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Giver Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, index) => (
                      <td key={`giver-${index}`}>{entry.name || 'Unknown'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Receiver Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, index) => (
                      <td key={`receiver-${index}`}>
                        {entry.user?.firstName} {entry.user?.lastName}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th>Amount <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, index) => (
                      <td key={`amount-${index}`}>{entry.amount}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Type <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, index) => (
                      <td key={`type-${index}`}>{entry.type}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default ThankYouReview;
